import { useTranslation } from 'react-i18next'

import { DRAFT_CREATE_ACTION, isDraftOpenAction } from '../../../Draft'
import { RadioGroupModal } from '../../../Radio'
import { getListingDraftFormValues } from '../../RentalPortalListing.utils'
import { QA_NAME_LISTING_DRAFT_CREATE_ACTION_MODAL } from '../RentalPortalListingDraft.constants'

import { LISTING_DRAFT_CREATE_ACTION_FIELD_NAME } from './RentalPortalListingDraftCreateActionSelectModal.constants'
import { getListingDraftCreateActionOptions } from './RentalPortalListingDraftCreateActionSelectModal.utils'

import * as styles from './RentalPortalListingDraftCreateActionSelectModal.module.css'

function RentalPortalListingDraftCreateActionSelectModal({
  draft,
  initialValues,
  onCancel,
  onSubmit,
}) {
  const { t } = useTranslation()

  function getOptions() {
    return getListingDraftCreateActionOptions({ draft, t })
  }

  function handleSubmit({ [LISTING_DRAFT_CREATE_ACTION_FIELD_NAME]: action }) {
    onSubmit?.({
      action,
      initialValues: isDraftOpenAction(action)
        ? getListingDraftFormValues(draft)
        : initialValues,
    })
  }

  return (
    <RadioGroupModal
      formFieldsProps={{
        getOptions,
        name: LISTING_DRAFT_CREATE_ACTION_FIELD_NAME,
        radioComponentProps: {
          labelProps: { className: styles.optionLabel },
        },
        submitProps: { title: 'Modal.ContinueBtnKey' },
        title: t('RentalPortal.ListingDraftCreateActionTitleKey'),
      }}
      initialValues={{
        [LISTING_DRAFT_CREATE_ACTION_FIELD_NAME]: DRAFT_CREATE_ACTION.openDraft,
      }}
      qaName={QA_NAME_LISTING_DRAFT_CREATE_ACTION_MODAL}
      title={t('RentalPortal.ListingDraftCreateModalTitleKey')}
      onCancel={onCancel}
      onClose={onCancel}
      onSubmit={handleSubmit}
    />
  )
}

export default RentalPortalListingDraftCreateActionSelectModal
